import {
  RISK_RULE_OPERATOR_GREATER_THAN,
  RISK_RULE_OPERATOR_LESS_THAN,
} from "../../constants";

import type {
  RiskRuleAlias,
  RiskRuleBase,
  RiskRuleNumberOfTransactionsAlias,
  RiskRuleVolumeOfTransactionsAlias,
} from "../../models/RiskRule";

export type ParserType<T extends RiskRuleBase> = (
  rule: T,
  bankName?: string
) => string;

export const COUNTRY_DICTIONARY = {
  include: "in",
  exclude: "outside",
} as const;

export const FILTER_NOT_INCLUDED = "";

export const TRANSACTION_AMOUNT_DICTIONARY = {
  [RISK_RULE_OPERATOR_GREATER_THAN]: "over",
  [RISK_RULE_OPERATOR_LESS_THAN]: "below",
};

export const generatePeriodText = ({
  payload,
}: Pick<
  RiskRuleVolumeOfTransactionsAlias | RiskRuleNumberOfTransactionsAlias,
  "payload"
>) => {
  if (payload.period) {
    const plural = payload.period === 1 ? "" : "s";

    return ` during ${payload.period}\xa0${payload.periodType}${plural}`;
  }

  return FILTER_NOT_INCLUDED;
};

export const generateCountryText = ({
  filter,
  bankName,
}: Pick<RiskRuleAlias, "filter"> & { bankName?: string }) => {
  if (filter.country) {
    const banksInclusionTypeText = COUNTRY_DICTIONARY[filter.country.type];
    const foundCountry = filter.country.values.find(
      (filterBank) => filterBank === bankName
    );

    return ` for banks ${banksInclusionTypeText} ${
      foundCountry ?? filter.country.values.join(", ")
    }`;
  }

  return FILTER_NOT_INCLUDED;
};
